import { render } from "./TransactionDetailsModal.vue?vue&type=template&id=90560834&scoped=true"
import script from "./TransactionDetailsModal.vue?vue&type=script&lang=js"
export * from "./TransactionDetailsModal.vue?vue&type=script&lang=js"

import "./TransactionDetailsModal.vue?vue&type=style&index=0&id=90560834&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90560834"]])

export default __exports__